import React from 'react'
import Redirect from '#src/components/Redirect'
import TeaserChatWidgetWithExpert from '#src/components/EngagementChannels/TeaserChatWidgetWithExpert'
import { withAnalytics, WithAnalyticsProps } from '#src/containers/Analytics'
import config from '#src/config'
import cookies from 'js-cookie'
import { generateCreateUrlFromCategory } from '#src/services/path'
import EngagementModalContent from './EngagementModalContent'
import { ExperimentPlacements } from '../EngagementChannelHandler'
import { EngagementChannelCategoryFragment } from '#src/generated/graphql'

interface EngagementModalProps extends WithAnalyticsProps {
  placement: ExperimentPlacements
  category: EngagementChannelCategoryFragment
}

interface EnagementModalState {
  redirect?: string
  isEngagementModalOpen: boolean
  isTeaserChatOpen: boolean
}

class EngagementModal extends React.Component<EngagementModalProps, EnagementModalState> {
  constructor(props: EngagementModalProps) {
    super(props)

    this.state = {
      isEngagementModalOpen: false,
      isTeaserChatOpen: false
    }

    this.handleCloseModal = this.handleCloseModal.bind(this)
    this.handleSubmitModal = this.handleSubmitModal.bind(this)
  }

  public componentDidMount() {
    const hasEngagementModalBeenViewed = cookies.get('engagement_modal_viewed')

    if (!hasEngagementModalBeenViewed) {
      setTimeout(() => {
        this.setState({
          isEngagementModalOpen: true
        })
      }, 2000)
    }
  }

  public handleCloseModal(trackDismiss: boolean, setCookie: boolean, variation: string) {
    this.setState(
      {
        isEngagementModalOpen: false,
        isTeaserChatOpen: true
      },
      () => {
        if (setCookie) {
          cookies.set('engagement_modal_viewed', 'true', {
            expires: 1,
            domain: config.get('consumer.clientSideCookieDomain')
          })
        }

        if (this.props.analytics && trackDismiss) {
          this.props.analytics.events.engagementChannelDismissed({
            engagement_channel: 'engagement-modal',
            variation,
            category: this.props.category.slug
          })
        }
      }
    )
  }

  public handleSubmitModal(categorySlug: string | null, variation: string) {
    if (this.props.analytics) {
      this.props.analytics.events?.engagementChannelSubmitted({
        engagement_channel: 'engagement-modal',
        variation,
        category: this.props.category.slug
      })
    }

    this.setState({
      redirect: generateCreateUrlFromCategory({
        maybeCategorySlug: categorySlug,
        sourceKey: 'engagement-modal-engagement-channel',
        pathIntent: 'request'
      })
    })
  }

  public render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />
    }

    const { category, placement } = this.props

    const pathCategorySlug = category.ancestorWithPath ? category.ancestorWithPath.slug : null
    const hasEngagementModalBeenViewed = cookies.get('engagement_modal_viewed')

    if (this.state.isTeaserChatOpen) {
      return <TeaserChatWidgetWithExpert categoryId={category.id} />
    }

    // No path category or path available, or seen already, then return null
    if (!pathCategorySlug || hasEngagementModalBeenViewed) {
      return null
    }

    const contentfulVariationSlug = `${pathCategorySlug}-${placement}`

    return (
      <EngagementModalContent
        isModalOpen={this.state.isEngagementModalOpen}
        contentfulVariationSlug={contentfulVariationSlug}
        category={category}
        onDismissModal={(trackDismiss, setCookie) =>
          this.handleCloseModal(trackDismiss, setCookie, contentfulVariationSlug)
        }
        onSubmitModal={() => this.handleSubmitModal(pathCategorySlug, contentfulVariationSlug)}
      />
    )
  }
}

export default withAnalytics(EngagementModal)
